import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import('@/assets/pages/HomePage.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/assets/pages/AboutPage.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/assets/pages/ContactPage.vue')
  },
  {
    path: '/games',
    name: 'Games',
    component: () => import('@/assets/pages/Games.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router